module.exports = __webpack_public_path__ + "img/tx.7835b9fe.png";